import { render, staticRenderFns } from "./IssuetrackingCreate.vue?vue&type=template&id=202c459a&scoped=true"
import script from "./IssuetrackingCreate.vue?vue&type=script&lang=js"
export * from "./IssuetrackingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202c459a",
  null
  
)

export default component.exports